import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.assign";
import React from 'react';
import styled, { css, keyframes } from 'styled-components';
import { InfoIcon, AlertIcon, WarningIcon, ErrorIcon, CloseIcon } from '@tinacms/icons';
import { useSubscribable } from '@tinacms/react-core';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n  border: none;\n  background: transparent;\n  padding: 0;\n  margin-left: 14px;\n  outline: none;\n  fill: var(--tina-color-grey-5);\n  display: flex;\n  align-items: center;\n\n  svg {\n    width: 20px;\n    height: 20px;\n    flex: 0 0 auto;\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n      fill: var(--tina-color-error);\n      border-left: 6px solid var(--tina-color-error);\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n      fill: var(--tina-color-warning-dark);\n      border-left: 6px solid var(--tina-color-warning);\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n      fill: var(--tina-color-success);\n      border-left: 6px solid var(--tina-color-success);\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n      fill: var(--tina-color-primary);\n      border-left: 6px solid var(--tina-color-primary);\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  border: 0;\n  border-radius: var(--tina-radius-small);\n  box-shadow: var(--tina-shadow-small);\n  background-color: var(--tina-color-grey-1);\n  border: 1px solid var(--tina-color-grey-2);\n  color: var(--tina-color-grey-9);\n  fill: var(--tina-color-primary);\n  font-weight: 500;\n  cursor: pointer;\n  font-size: var(--tina-font-size-2);\n  padding: 8px 4px 8px 12px;\n  transition: all var(--tina-timing-short) ease-out;\n  margin-bottom: 16px;\n  display: flex;\n  align-items: center;\n  min-width: 350px;\n  max-width: 100%;\n\n  animation-name: ", ";\n  animation-timing-function: ease-out;\n  animation-iteration-count: 1;\n  animation-fill-mode: both;\n  animation-duration: 150ms;\n\n  p {\n    margin: 0;\n    flex: 1 0 auto;\n    text-align: left;\n  }\n\n  svg {\n    width: 20px;\n    height: 20px;\n    margin-right: 8px;\n    flex: 0 0 auto;\n  }\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  0% {\n    opacity: 0;\n    transform: translate3d(0, 100%, 0);\n  }\n  100% {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function Alerts(_ref) {
  var alerts = _ref.alerts;
  useSubscribable(alerts);
  return React.createElement(React.Fragment, null, alerts.all.length > 0 && React.createElement(AlertContainer, null, alerts.all.map(function (alert, i) {
    return React.createElement(Alert, {
      key: alert.id,
      index: i,
      level: alert.level,
      onClick: function onClick() {
        alerts.dismiss(alert);
      }
    }, alert.level === 'info' && React.createElement(InfoIcon, null), alert.level === 'success' && React.createElement(AlertIcon, null), alert.level === 'warn' && React.createElement(WarningIcon, null), alert.level === 'error' && React.createElement(ErrorIcon, null), React.createElement("p", null, alert.message), React.createElement(CloseAlert, null));
  })));
}

var AlertContainer = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject());
var AlertEntranceAnimation = /*#__PURE__*/keyframes( /*#__PURE__*/_templateObject2());
var Alert = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject3(), AlertEntranceAnimation, function (props) {
  return props.level === 'info' && css(_templateObject4());
}, function (props) {
  return props.level === 'success' && css(_templateObject5());
}, function (props) {
  return props.level === 'warn' && css(_templateObject6());
}, function (props) {
  return props.level === 'error' && css(_templateObject7());
});
var CloseAlert = /*#__PURE__*/styled(function (_ref2) {
  var styleProps = _extends({}, _ref2);

  return React.createElement("button", Object.assign({}, styleProps), React.createElement(CloseIcon, null));
})( /*#__PURE__*/_templateObject8());
export { Alerts };